import React from "react";
import { Link } from "react-router-dom";

export default function BlogListItem({ blog = {} }) {
  const { id, title, image, tags, likes, isSaved, createdAt } = blog;

  let tagContent = null;
  tagContent = tags?.length > 0 && tags.map((tag) => `#${tag}`).join(`, `);
  return (
    <>
      {/* <!-- single post --> */}
      <div className="lws-card">
        <Link to={`blogs/${id}`}>
          <img src={image} className="lws-card-image" alt={title} />
        </Link>
        <div className="p-4">
          <div className="lws-card-header">
            <p className="lws-publishedDate">{createdAt}</p>
            <p className="lws-likeCount">
              <i className="fa-regular fa-thumbs-up"></i>
              {likes}
            </p>
          </div>
          <Link to={`blogs/${id}`} className="lws-postTitle">
            {title}
          </Link>
          <div className="lws-tags">
            {/* <span>#python,</span> <span>#tech,</span> <span>#git</span> */}
            <span>{tagContent}</span>
          </div>
          {/* <!-- Show this element if post is saved --> */}
          <div className="flex gap-2 mt-4">
            <span className={`${isSaved && "lws-badge"}`}>
              {" "}
              {isSaved && "Saved"}{" "}
            </span>
          </div>
          {/* <!-- Show this element if post is saved Ends --> */}
        </div>
      </div>
      {/* <!-- Single Post Ends --> */}
    </>
  );
}
